import { createEvent, sample } from 'effector'
import { CreateFileManagerFormItem, UpdateFileManagerFormItem } from './types'
import { fx } from '../../../../../../libs'
import { $params } from '../../../../../../features/router'

export const submitCreateSocialMediaFile =
  createEvent<CreateFileManagerFormItem>()

export const submitUpdateSocialMediaFile =
  createEvent<UpdateFileManagerFormItem>()

export const createFileManagerFile = fx<CreateFileManagerFormItem, void>({
  method: 'POST',
  url: '/partner/material/social_media_file',
})

export const updateFileManagerFile = fx<UpdateFileManagerFormItem, void>({
  method: 'POST',
  url: '/partner/material/social_media_file/${id}',
})

sample({
  clock: submitCreateSocialMediaFile,
  source: $params,
  fn: (params, socialMediaFile) => {
    let id
    if (params) {
      id = params.socialMediaID
    }

    return {
      url: `/partner/material/social_media_file`,
      formData: {
        ...socialMediaFile,
        socialMediaId: Number(id),
        platformsList: socialMediaFile.platforms,
      },
    }
  },
  target: createFileManagerFile,
})

sample({
  clock: submitUpdateSocialMediaFile,
  source: $params,
  fn: (params, socialMediaFile) => {
    let id
    if (params) {
      id = params.socialMediaID
    }

    return {
      url: `/partner/material/social_media_file/${socialMediaFile.id}`,
      formData: {
        ...socialMediaFile,
        socialMediaId: Number(id),
        platformsList: socialMediaFile.platforms,
      },
    }
  },
  target: updateFileManagerFile,
})
